module.exports = __webpack_public_path__ + "img/bubbles.642c04f2.svg";